var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPiczright(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 87,
    width: 262,
    height: 261,
    rx: 24,
    fill: "black",
    stroke: "url(#paint0_linear_94_257)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 45.489V216.489C171.26 216.882 171.104 217.259 170.826 217.537C170.548 217.816 170.17 217.972 169.777 217.972H68.4828C68.0896 217.972 67.7124 217.816 67.4343 217.537C67.1562 217.259 67 216.882 67 216.489V45.489C67 45.0958 67.1562 44.7186 67.4343 44.4405C67.7124 44.1624 68.0896 44.0062 68.4828 44.0062H100.508C100.925 44.0062 101.324 44.1715 101.618 44.4657C101.912 44.76 102.077 45.159 102.077 45.5752V49.1684C102.077 49.5845 102.243 49.9836 102.537 50.2779C102.831 50.5721 103.23 50.7374 103.646 50.7374H134.62C135.036 50.7374 135.435 50.5721 135.729 50.2779C136.023 49.9836 136.189 49.5845 136.189 49.1684V45.5752C136.189 45.159 136.354 44.76 136.648 44.4657C136.943 44.1715 137.342 44.0062 137.758 44.0062H169.753C169.949 44.0029 170.145 44.0389 170.328 44.1119C170.51 44.185 170.677 44.2937 170.817 44.4317C170.957 44.5697 171.069 44.7343 171.145 44.9158C171.221 45.0974 171.26 45.2922 171.26 45.489Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 60.8772H67V76.5854H171.26V60.8772Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 108.057H123.069",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1133 115.422H157.626",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 120.923H157.623",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 126.424H157.623",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 131.918H157.623",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 137.419H157.623",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 142.919H157.623",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 148.414H116.381",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 66.7963H163.459",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 68.6113H163.459",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 70.4203H163.459",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.928 68.6113H74.6055",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1292 70.6172L74.1172 68.6052L76.1292 66.5933",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.73 66.7963H148.777V70.4141H153.73V66.7963Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.777 66.7963L151.251 68.6052L153.73 66.7963",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142.379 71.1156H139.045L138.602 66.7963H142.822L142.379 71.1156Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.879 66.7962V66.101H141.546V66.7962",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 205.494V216.489C171.261 216.683 171.223 216.876 171.149 217.056C171.075 217.236 170.967 217.399 170.83 217.537C170.692 217.675 170.529 217.784 170.35 217.859C170.17 217.933 169.978 217.972 169.783 217.972H68.4828C68.0896 217.972 67.7124 217.816 67.4343 217.537C67.1562 217.259 67 216.882 67 216.489V205.494H171.26Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.457 89.8202H135.899",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6549 94.9832C88.5094 94.5199 90.4477 91.8303 89.9844 88.9759C89.5211 86.1214 86.8315 84.1831 83.977 84.6464C81.1226 85.1097 79.1842 87.7993 79.6475 90.6538C80.1109 93.5082 82.8005 95.4466 85.6549 94.9832Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9539 93.0936C86.6339 93.0936 85.7233 92.3922 86.031 91.8199C86.3386 91.2477 86.9539 90.3002 86.9539 90.3002C87.2245 89.7669 87.3757 89.1811 87.3969 88.5835C87.5261 87.6914 87.0154 86.1716 84.8127 86.1716C82.61 86.1716 82.0931 87.6914 82.2224 88.5835C82.2436 89.1811 82.3947 89.7669 82.6654 90.3002C82.6654 90.3002 83.2806 91.2477 83.5944 91.8199C83.9082 92.3922 82.9791 93.0936 82.6654 93.0936C82.1508 93.2083 81.6482 93.3711 81.1641 93.5797C81.1641 93.5797 83.2745 95.0625 84.8127 95.0625C86.3509 95.0625 88.4613 93.5797 88.4613 93.5797C87.9754 93.3703 87.4706 93.2075 86.9539 93.0936Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67 159.274H171.26",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 187.897H67V205.494H171.26V187.897Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.379 165.876H156.993C157.801 165.876 158.576 166.196 159.147 166.768C159.718 167.339 160.039 168.113 160.039 168.921V177.535C160.039 178.343 159.718 179.118 159.147 179.689C158.576 180.26 157.801 180.581 156.993 180.581H148.379C147.573 180.581 146.8 180.261 146.23 179.691C145.66 179.121 145.34 178.348 145.34 177.541V168.927C145.338 168.527 145.416 168.131 145.568 167.76C145.72 167.39 145.943 167.054 146.226 166.77C146.508 166.487 146.844 166.262 147.213 166.108C147.583 165.955 147.979 165.876 148.379 165.876Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.432 172.078L152.499 170.01C152.711 169.798 152.963 169.63 153.24 169.515C153.517 169.4 153.814 169.341 154.114 169.341C154.414 169.341 154.711 169.4 154.988 169.515C155.265 169.63 155.517 169.798 155.729 170.01C156.158 170.44 156.399 171.022 156.399 171.628C156.399 172.235 156.158 172.817 155.729 173.247L152.364 176.612C152.222 176.754 152.054 176.867 151.868 176.944C151.683 177.021 151.484 177.06 151.284 177.06C151.083 177.06 150.885 177.021 150.699 176.944C150.514 176.867 150.346 176.754 150.204 176.612C149.921 176.326 149.762 175.939 149.762 175.536C149.762 175.132 149.921 174.746 150.204 174.459L153.403 171.259C153.537 171.126 153.719 171.05 153.908 171.05C154.097 171.05 154.279 171.126 154.412 171.259C154.479 171.325 154.533 171.404 154.569 171.49C154.605 171.577 154.624 171.67 154.624 171.764C154.624 171.858 154.605 171.951 154.569 172.037C154.533 172.124 154.479 172.203 154.412 172.268L152.684 173.991",
    stroke: "#263238",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 170.459H138.365",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6328 175.96H128.736",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3345 192.247H82.2224C81.0943 192.247 80.1797 193.161 80.1797 194.289V199.003C80.1797 200.131 81.0943 201.045 82.2224 201.045H93.3345C94.4626 201.045 95.3772 200.131 95.3772 199.003V194.289C95.3772 193.161 94.4626 192.247 93.3345 192.247Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8866 197.643L85.4961 196.252L86.8866 194.862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M125.065 192.247H113.953C112.825 192.247 111.91 193.161 111.91 194.289V199.003C111.91 200.131 112.825 201.045 113.953 201.045H125.065C126.193 201.045 127.108 200.131 127.108 199.003V194.289C127.108 193.161 126.193 192.247 125.065 192.247Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.535 198.436V197.821C122.535 197.408 122.371 197.012 122.079 196.72C121.787 196.429 121.391 196.265 120.978 196.265H118.406",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M119.336 197.643L117.945 196.252L119.336 194.862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M117.897 197.643L116.5 196.252L117.897 194.862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.408 201.051H157.52C158.648 201.051 159.562 200.137 159.562 199.009V194.296C159.562 193.167 158.648 192.253 157.52 192.253H146.408C145.28 192.253 144.365 193.167 144.365 194.296V199.009C144.365 200.137 145.28 201.051 146.408 201.051Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M149.676 198.436V197.821C149.676 197.408 149.84 197.012 150.132 196.72C150.424 196.429 150.82 196.265 151.232 196.265H153.804",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.855 197.643L154.246 196.252L152.855 194.862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 45.4828V60.865H67V45.4828C67 45.0896 67.1562 44.7124 67.4343 44.4343C67.7124 44.1562 68.0896 44 68.4828 44H100.508C100.925 44 101.324 44.1653 101.618 44.4595C101.912 44.7538 102.077 45.1529 102.077 45.569V49.1622C102.077 49.5784 102.243 49.9774 102.537 50.2717C102.831 50.5659 103.23 50.7312 103.646 50.7312H134.62C135.036 50.7312 135.435 50.5659 135.729 50.2717C136.023 49.9774 136.189 49.5784 136.189 49.1622V45.5751C136.189 45.159 136.354 44.7599 136.648 44.4657C136.943 44.1715 137.342 44.0062 137.758 44.0062H169.753C169.949 44.0012 170.145 44.0358 170.328 44.1079C170.511 44.1799 170.678 44.288 170.819 44.4257C170.959 44.5634 171.071 44.7279 171.146 44.9095C171.222 45.0911 171.261 45.2861 171.26 45.4828Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M297.01 273H231.95C228.664 273 226 275.664 226 278.95V354.58C226 357.866 228.664 360.53 231.95 360.53H297.01C300.296 360.53 302.96 357.866 302.96 354.58V278.95C302.96 275.664 300.296 273 297.01 273Z",
    fill: "#FD1065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 292,
    width: 40,
    height: 56
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M281.198 292.21H242.828V347.14H281.198V292.21Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_257)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M281.198 292.21H242.828V347.14H281.198V292.21Z",
    fill: "#FD1065"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M281.198 292.21H242.828V347.14H281.198V292.21Z",
    stroke: "#FD1065",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M279.944 284.451L242.316 291.963L253.07 345.83L290.698 338.319L279.944 284.451Z",
    fill: "#FD1065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M245.129 291.13C245.411 290.45 245.889 289.868 246.501 289.459C247.113 289.05 247.833 288.831 248.569 288.83C249.553 288.83 250.497 289.221 251.192 289.917C251.888 290.612 252.279 291.556 252.279 292.54V300.28C252.279 300.936 252.019 301.565 251.556 302.03C251.093 302.495 250.465 302.757 249.809 302.76C249.151 302.76 248.52 302.499 248.055 302.034C247.59 301.568 247.329 300.938 247.329 300.28V292.93C247.329 292.622 247.451 292.327 247.669 292.11C247.886 291.892 248.181 291.77 248.489 291.77C248.641 291.77 248.792 291.8 248.933 291.858C249.074 291.917 249.201 292.002 249.309 292.11C249.417 292.217 249.502 292.345 249.561 292.486C249.619 292.627 249.649 292.778 249.649 292.93V296.88",
    stroke: "#FD1065",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M256.09 328.58L271.05 325.6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M255.379 324.77L281.429 319.57",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M254.68 320.96L280.72 315.76",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M253.969 317.15L280.009 311.95",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M253.262 313.33L279.302 308.13",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M252.551 309.52L278.591 304.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M251.84 305.71L277.88 300.51",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M258.078 300.51L277.168 296.7",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.55 150.11V203.92H229V135H272.44L282.6 145.16L287.55 150.11Z",
    fill: "#FD1065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M242.02 145.36H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 152.25H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 159.15H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 166.04H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 172.94H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 179.83H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 186.72H279.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68 193.62H274.65",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M287.551 150.11H272.441V135L282.601 145.16L287.551 150.11Z",
    fill: "#FD1065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M148.868 266.646V320.456H90.3281V251.536H133.768L143.918 261.696L148.868 266.646Z",
    fill: "#FD1065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M103.352 261.896H141.322",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M98 268.796H141.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M98 275.686H141.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M98 282.576H141.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M98 289.476H141.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M98 296.365H141.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M98 303.266H141.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98 310.156H135.98",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M148.87 266.646H133.77V251.536L143.92 261.696L148.87 266.646Z",
    fill: "#FD1065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M155.199 323.115V329.115H149.199",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M139.362 329.115H97.9219",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.84 11.84"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M90 329.115H84V323.115",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M84 312.506V254.186",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.6 10.6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M84 248.885V242.885H90",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M101.84 242.885H143.28",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.84 11.84"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M155.199 259.486V317.806",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.6 10.6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M112.99 317.456L109.73 316.206L110.51 319.906L112.99 317.456Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M159.134 251.731C162.582 248.283 162.582 242.692 159.134 239.244C155.685 235.795 150.094 235.795 146.646 239.244C143.198 242.692 143.198 248.283 146.646 251.731C150.094 255.18 155.685 255.18 159.134 251.731Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M152.891 240.936V250.036",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M157.442 245.486H148.352",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_94_257",
    x1: 55,
    y1: 217.5,
    x2: 319,
    y2: 217.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E30147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#EC36B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#A856EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#9865FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiczright);
export default __webpack_public_path__ + "static/media/piczright.afffaebce704f27cf469d468d7d10912.svg";
export { ForwardRef as ReactComponent };